/* chats feature – action creators & thunks */
import { Dispatch } from "redux";
import {
  ChatViewModel,
  ChatDetailsViewModel,
  CreateChatCommand,
  SendChatMessageCommand,
} from "../../configuration/api/apiSchema";
import { api } from "../../configuration/api/apiHelper"; // <- your helper that wraps the generated Api

/* ────────────────────────────────────────────────────────────── */
/*  BASIC CRUD THUNKS                                             */
/* ────────────────────────────────────────────────────────────── */

// Get all chats for the current user
export const getChats = () => async (dispatch: Dispatch) => {
  dispatch({ type: "GET_CHATS_REQUEST" });
  try {
    const res = await api.chats.chatsList();
    dispatch({ type: "GET_CHATS_SUCCESS", payload: res.data });
  } catch (err) {
    dispatch({ type: "GET_CHATS_FAILURE", payload: err });
  }
};

// Get a single chat with its messages
export const getChatDetails = (chatId: string) => async (dispatch: Dispatch) => {
  dispatch({ type: "GET_CHAT_DETAILS_REQUEST" });
  try {
    const res = await api.chats.chatsDetail(chatId);
    dispatch({ type: "GET_CHAT_DETAILS_SUCCESS", payload: res.data });
  } catch (err) {
    dispatch({ type: "GET_CHAT_DETAILS_FAILURE", payload: err });
  }
};

// Create a new chat (returns the chat-id so the caller can redirect)
export const createChat =
  (payload: CreateChatCommand) => async (dispatch: Dispatch) => {
    dispatch({ type: "CREATE_CHAT_REQUEST" });
    try {
      const res = await api.chats.chatsCreate(payload);
      dispatch({ type: "CREATE_CHAT_SUCCESS", payload: res.data }); // res.data === id
      return res.data;
    } catch (err) {
      dispatch({ type: "CREATE_CHAT_FAILURE", payload: err });
      throw err;
    }
  };

// Send a message to a chat
export const sendMessage =
  (chatId: string, payload: SendChatMessageCommand) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: "SEND_MESSAGE_REQUEST" });
    try {
      const res = await api.chats.messagesCreate(chatId, payload);
      dispatch({ type: "SEND_MESSAGE_SUCCESS", payload: res.data });
    } catch (err) {
      dispatch({ type: "SEND_MESSAGE_FAILURE", payload: err });
    }
  };

/* ────────────────────────────────────────────────────────────── */
/*  SEARCH THUNK + ACTION TYPES                                   */
/* ────────────────────────────────────────────────────────────── */

export const SEARCH_CHATS_REQUEST  = "chats/SEARCH_REQUEST";
export const SEARCH_CHATS_SUCCESS  = "chats/SEARCH_SUCCESS";
export const SEARCH_CHATS_FAILURE  = "chats/SEARCH_FAILURE";

export const searchChats =
  (searchValue: string) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: SEARCH_CHATS_REQUEST, payload: searchValue });

    try {
      // POST /chats/search?searchValue=...
      const { data } = await api.chats.searchCreate({ searchValue });
      dispatch({
        type: SEARCH_CHATS_SUCCESS,
        payload: (data ?? []) as ChatViewModel[],
      });
    } catch (err: any) {
      dispatch({
        type: SEARCH_CHATS_FAILURE,
        payload: err?.message ?? "Failed to search chats",
      });
    }
  };

// Silent polling actions - don't trigger loading states to avoid UI interference
export const getChatsPolling = () => async (dispatch: Dispatch) => {
  try {
    const res = await api.chats.chatsList();
    dispatch({ type: "GET_CHATS_POLLING_SUCCESS", payload: res.data });
  } catch (err) {
    // Silent error handling for polling
    console.warn("Chat list polling failed:", err);
  }
};

export const getChatDetailsPolling = (chatId: string) => async (dispatch: Dispatch) => {
  try {
    const res = await api.chats.chatsDetail(chatId);
    dispatch({ type: "GET_CHAT_DETAILS_POLLING_SUCCESS", payload: res.data });
  } catch (err) {
    // Silent error handling for polling
    console.warn("Chat details polling failed:", err);
  }
};
